var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark-Pink-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 13.3335,
    y: 19.1094,
    width: 37.3333,
    height: 26.6667,
    rx: 5.33333,
    fill: "url(#paint0_linear_478_4207)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_478_4207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 12.4429C24.0002 10.2337 22.2093 8.44287 20.0002 8.44287C17.791 8.44287 16.0002 10.2337 16.0002 12.4429V42.786L12.1619 38.9478C10.5998 37.3857 8.06717 37.3857 6.50507 38.9478C4.94297 40.5099 4.94297 43.0425 6.50507 44.6046L17.1717 55.2713C18.7338 56.8334 21.2665 56.8334 22.8286 55.2713L33.4953 44.6046C35.0574 43.0425 35.0574 40.5099 33.4953 38.9478C31.9332 37.3857 29.4005 37.3857 27.8384 38.9478L24.0002 42.786V12.4429Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 12.4429C24.0002 10.2337 22.2093 8.44287 20.0002 8.44287C17.791 8.44287 16.0002 10.2337 16.0002 12.4429V42.786L12.1619 38.9478C10.5998 37.3857 8.06717 37.3857 6.50507 38.9478C4.94297 40.5099 4.94297 43.0425 6.50507 44.6046L17.1717 55.2713C18.7338 56.8334 21.2665 56.8334 22.8286 55.2713L33.4953 44.6046C35.0574 43.0425 35.0574 40.5099 33.4953 38.9478C31.9332 37.3857 29.4005 37.3857 27.8384 38.9478L24.0002 42.786V12.4429Z",
    fill: "url(#paint1_linear_478_4207)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 22.0997V52.4429C48.0002 54.652 46.2093 56.4429 44.0002 56.4429C41.791 56.4429 40.0002 54.652 40.0002 52.4429V22.0997L36.1619 25.938C34.5998 27.5001 32.0672 27.5001 30.5051 25.938C28.943 24.3759 28.943 21.8432 30.5051 20.2811L41.1717 9.61445C42.7338 8.05235 45.2665 8.05235 46.8286 9.61445L57.4953 20.2811C59.0574 21.8432 59.0574 24.3759 57.4953 25.938C55.9332 27.5001 53.4005 27.5001 51.8384 25.938L48.0002 22.0997Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 22.0997V52.4429C48.0002 54.652 46.2093 56.4429 44.0002 56.4429C41.791 56.4429 40.0002 54.652 40.0002 52.4429V22.0997L36.1619 25.938C34.5998 27.5001 32.0672 27.5001 30.5051 25.938C28.943 24.3759 28.943 21.8432 30.5051 20.2811L41.1717 9.61445C42.7338 8.05235 45.2665 8.05235 46.8286 9.61445L57.4953 20.2811C59.0574 21.8432 59.0574 24.3759 57.4953 25.938C55.9332 27.5001 53.4005 27.5001 51.8384 25.938L48.0002 22.0997Z",
    fill: "url(#paint2_linear_478_4207)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8116 42.9746C15.8879 43.0508 16.0026 43.0737 16.1022 43.0324C16.2019 42.9911 16.2668 42.8939 16.2668 42.786V12.4429C16.2668 10.381 17.9383 8.70954 20.0002 8.70954C22.062 8.70954 23.7335 10.381 23.7335 12.4429V42.786C23.7335 42.8939 23.7985 42.9911 23.8981 43.0324C23.9978 43.0737 24.1125 43.0508 24.1887 42.9746L28.027 39.1363C29.4849 37.6784 31.8487 37.6784 33.3067 39.1363C34.7647 40.5943 34.7647 42.9581 33.3067 44.4161L22.64 55.0827C21.1821 56.5407 18.8183 56.5407 17.3603 55.0827L6.69363 44.4161C5.23567 42.9581 5.23567 40.5943 6.69363 39.1363C8.15159 37.6784 10.5154 37.6784 11.9734 39.1363L15.8116 42.9746ZM48.1887 21.9112C48.1125 21.8349 47.9978 21.8121 47.8981 21.8534C47.7985 21.8946 47.7335 21.9919 47.7335 22.0997V52.4429C47.7335 54.5047 46.062 56.1762 44.0002 56.1762C41.9383 56.1762 40.2668 54.5047 40.2668 52.4429V22.0997C40.2668 21.9919 40.2019 21.8946 40.1022 21.8534C40.0026 21.8121 39.8879 21.8349 39.8116 21.9112L35.9734 25.7494C34.5154 27.2074 32.1516 27.2074 30.6936 25.7494C29.2357 24.2914 29.2357 21.9276 30.6936 20.4697L41.3603 9.80301C42.8183 8.34505 45.1821 8.34505 46.64 9.80301L57.3067 20.4697C58.7647 21.9276 58.7647 24.2914 57.3067 25.7494C55.8487 27.2074 53.4849 27.2074 52.027 25.7494L48.1887 21.9112Z",
    stroke: "url(#paint3_linear_478_4207)",
    strokeOpacity: 0.1,
    strokeWidth: 0.533333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_478_4207",
    x: 2.3335,
    y: 5.44287,
    width: 59.3335,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_478_4207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_478_4207",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_4207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_4207",
    x1: 14.8891,
    y1: 24.4427,
    x2: 54.8593,
    y2: 32.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_478_4207",
    x1: 7.55572,
    y1: 18.0429,
    x2: 65.4366,
    y2: 26.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_478_4207",
    x1: 7.55572,
    y1: 18.0429,
    x2: 65.4366,
    y2: 26.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_478_4207",
    x1: 7.00016,
    y1: 10.6247,
    x2: 58.6668,
    y2: 10.6247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.4deb1b25c080a6366fa9bc9ccd0dbb84.svg";
export { ForwardRef as ReactComponent };